import RestApi from './../../api/rest-api-client'
const srvcEndpoint = '/notifications'
export default {
  email: async (data, opts) => RestApi.request('POST', `${srvcEndpoint}/emails`, data, opts),
}
